import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import AnnouncementBarSchema from './schema';
import AnnouncementBarBody from './AnnouncementBarBody';
import type { AnnouncementBarData } from './AnnouncementBarBody';

type AnnouncementBarEditProps = {
  data: AnnouncementBarData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: AnnouncementBarData) => void;
};

const AnnouncementBarEdit = (props: AnnouncementBarEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = AnnouncementBarSchema({ intl });

  return (
    <>
      <AnnouncementBarBody data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default AnnouncementBarEdit;
